import { render, staticRenderFns } from "./PhysicalItemsLog.vue?vue&type=template&id=44576d4e&scoped=true"
import script from "./PhysicalItemsLog.vue?vue&type=script&lang=js"
export * from "./PhysicalItemsLog.vue?vue&type=script&lang=js"
import style0 from "./PhysicalItemsLog.vue?vue&type=style&index=0&id=44576d4e&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44576d4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44576d4e')) {
      api.createRecord('44576d4e', component.options)
    } else {
      api.reload('44576d4e', component.options)
    }
    module.hot.accept("./PhysicalItemsLog.vue?vue&type=template&id=44576d4e&scoped=true", function () {
      api.rerender('44576d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationRecord/physicalItemsLog/PhysicalItemsLog.vue"
export default component.exports